import React, { useState, useEffect } from 'react'
import { getGrowersNamesFromProdPlan, postScaleTicket, patchScaleTicket } from '../../../services/apiHelper'
import {  Modal, Button } from 'syngenta-react-components'
import Select from '../../../dpe-usco/components/Select/Select'
import { useForm, Controller } from 'react-hook-form'
import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'
import greenCheck from '../../../assets/icons/circle_check_green.svg'
import error_outline from '../../../assets/icons/error_outline.svg'
import close from '../../../assets/icons/close.svg'

const customClass = {
  buttonClassNames: 'bgc-white bd2-s-input bdrs-4 h48 df aic jcsb mt5 pl10 pt10 pb10 pr15'
}

const SingleTicketUpload = ({  editData, setShowModal, showModal, prodPlanID, scaleTicketsYear, setFetchScaleTickets, fetchScaleTickets, editScaleId }) => {
  const [rvaPass, setRvaPass] = useState(true)
  const [growersFromProdPlan, setGrowersFromProdPlan] = useState([])
  const [growerContract, setGrowerContract] = useState()
  const [status, setStatus] = useState('INIT')
  const [growerNewContract, setGrowerNewContract] = useState()
  const [dateVal, setDateVal] = useState()
  const [growerVal, setGrowerVal] = useState()
  const [statusMessage, setStatusMessage] = useState([])

  const { register, handleSubmit, control, setValue } = useForm({
    defaultValues: {
      bol: editData && editData?.bill_of_lading?.toString(),
      ticketNumber: editData && editData?.scale_ticket_number?.toString(),
      dmg: editData && editData?.damage?.toString(),
      fm: editData && editData?.foreign_material?.toString(),
      grossLbs: editData && editData?.gross_weight?.toString(),
      grossQty: editData && editData?.gross_quantity?.toString(),
      grower: editData && `<div>${editData?.grower?.toString()}<br/>${editData?.new_contract_id ? editData?.new_contract_id:'NA'}</div>`,
      mo: editData && editData?.moisture?.toString(),
      netlbs: editData && editData?.net_weight?.toString(),
      netQty: editData && editData?.net_quantity?.toString(),
      rvaPass: editData && editData?.rapid_visco_analyzer ? '1' : '0',
      date: editData && new Date(editData?.scale_ticket_date),
      tare: editData && editData?.tare_weight?.toString(),
      tw: editData && editData?.test_weight?.toString(),
      notes: editData && editData?.notes?.toString()
    }
  })

  const convertTimestampToDate = timestamp => {
    const dateObject = new Date(timestamp)
    const year = dateObject.getUTCFullYear()
    const month = (dateObject.getUTCMonth() + 1).toString().padStart(2, '0')
    const day = dateObject.getUTCDate().toString().padStart(2, '0')
    return `${year}-${month}-${day}`
  }
  

  useEffect(()=>{
    if(editScaleId!=='') {
      setDateVal(convertTimestampToDate(editData?.scale_ticket_date))
      setGrowerVal(<div>{editData.grower_name?.toString()}<br/>{editData.original_new_contract_id ? editData.original_new_contract_id:'NA'}</div>)
      setGrowerNewContract(editData.original_new_contract_id || 'NA')
      setRvaPass(editData?.rapid_visco_analyzer === '1' ? true : false )
    }
  },[editData,editScaleId])

  const handleDateChange = e => {
    const v = (e.target.value || '').slice(0, 10)  
    setDateVal(v)
    setValue('date', v, { shouldValidate: true, shouldDirty: true })
  }


  const onSubmit = async formVal => {
    setStatus('LOADING')

    if(editScaleId === '') {
      let arg = {
        bill_of_landing_number: formVal?.bol?.toString(),
        external_reference_id: growerContract,
        scale_ticket_number: formVal?.ticketNumber?.toString(),
        damage: formVal?.dmg?.toString(),
        foreign_material: formVal?.fm?.toString(),
        gross_lbs: formVal?.grossLbs?.toString() || '0',
        gross_quantity: formVal?.grossQty?.toString(),
        grower_name: formVal.grower?.toString(),
        moisture: formVal?.mo?.toString(),
        net_lbs: formVal?.netlbs?.toString() || '0',
        net_quantity: formVal?.netQty?.toString(),
        production_plan_id: prodPlanID.toString(),
        rapid_visco_analyzer: rvaPass ? '1' : '0',
        scale_ticket_date: new Date(formVal.date),
        tar_lbs: formVal?.tare?.toString() || '0',
        test_weight: formVal?.tw?.toString(),
        original_new_contract_id: growerNewContract ? growerNewContract:null
      }
      if(formVal?.notes?.toString()) {
        arg = {
          ...arg,
          notes: formVal?.notes?.toString()
        }
      }
      setStatusMessage([])
      let response = await postScaleTicket({ scale_tickets: [arg] })
      if (response.status === 200) {
        setStatus('SUCCESS')
      } else {
        setStatus('ERROR')
        setStatusMessage(response.data.errors)
      }
    } else {
      let arg = {
        bill_of_landing_number: formVal?.bol?.toString(),
        damage: formVal?.dmg?.toString(),
        foreign_material: formVal?.fm?.toString(),
        gross_lbs: formVal?.grossLbs?.toString() || '0',
        gross_quantity: formVal?.grossQty?.toString(),
        moisture: formVal?.mo?.toString(),
        net_lbs: formVal?.netlbs?.toString() || '0',
        net_quantity: formVal?.netQty?.toString(),
        rapid_visco_analyzer: rvaPass ? '1' : '0',
        scale_ticket_date: new Date(formVal.date),
        tar_lbs: formVal?.tare?.toString() || '0',
        test_weight: formVal?.tw?.toString(),
        scale_ticket_id: editScaleId,
        production_plan_id: prodPlanID,
        grower_name: editData?.grower_name?.toString(),
        scale_ticket_number: editData?.scale_ticket_number,
        original_new_contract_id: growerNewContract ? growerNewContract : null

      }
      if(formVal?.notes?.toString()) {
        arg = {
          ...arg,
          notes: formVal?.notes?.toString()
        }
      }
      let response = await patchScaleTicket(arg, editScaleId, prodPlanID)
      if (response.status === 200) {
        setStatus('SUCCESS')
      } else {
        setStatus('ERROR')
      }
    }
  }

  const handleRva = (bool, e) => {
    e.preventDefault()
    setRvaPass(bool)
  }

  useEffect(() => {
    getGrowersNamesFromProdPlan(prodPlanID).then(res => {
      let growerList = res?.data?.contracts
      if(growerList?.length)
        growerList.sort(function(a, b) {
          const fName = a?.contract_details?.grower_details?.first + ' ' + a?.contract_details?.grower_details?.last
          const sName = b?.contract_details?.grower_details?.first + ' ' + b?.contract_details?.grower_details?.last
          var textA = fName.toUpperCase()
          var textB = sName.toUpperCase()
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
        })
      let options = growerList?.flatMap(contractObj => {
        const first = contractObj?.contract_details?.grower_details?.first
        const last = contractObj?.contract_details?.grower_details?.last
        if (first && last && (contractObj.contract_state === 'completed' || contractObj.contract_state === 'amendment_completed')) {
          return {
            value: <div>{first+' '+last}<br/>{contractObj.new_contract_id ? contractObj.new_contract_id:'NA'}</div>,
            sap_id: contractObj?.contract_details?.grower_details?.sap_id,
            external_reference_id: contractObj.external_reference_id,
            contract_id: contractObj.contract_id,
            new_contract_id: contractObj.new_contract_id
          }
        } else {
          return []
        }
      })
      setGrowersFromProdPlan(options)
    })
  }, [prodPlanID])
  
  const handleGrowerSelection = option => {
    setValue('grower', option.value.props.children[0])
    setGrowerContract(option.contract_id)
    setGrowerNewContract(option.new_contract_id)
  }

  const handleClose = () => {
    setFetchScaleTickets(!fetchScaleTickets)
    setShowModal(false)
    setStatus('INIT')
  }

  const renderContent = statusArg => {
    let content
    switch (statusArg) {
      case 'INIT':
        content = (<>
          <div className='df jcsb'>
            <p className='fz16 ml16 fw600'>{editScaleId === '' ? 'Scale Ticket Details' : 'Edit Scale Ticket'}</p>
          </div>
          <hr className='mt0 mb16 bdnone bt1-s-lightgray' />
          <div className='df fxdrr fxww'>
            <form className='w100% tal' onSubmit={handleSubmit(onSubmit)}>

              <div className='df jcsa  '>
                <div className='w45%'>
                  <label className='fz13' htmlFor='year'>Contract Year</label>
                  <input
                    disabled
                    className='bd2-s-input mt4 fz15 bgc-background-gray h48'
                    type="text"
                    id='year'
                    name="year"
                    value={scaleTicketsYear}
                    ref={register({ required: true })} />
                </div>
                <div className='w45%'>
                  <label className='fz13' htmlFor='grower'>Grower</label>
                  <Controller
                    as={<Select customClassName={customClass}
                      defaultId={growerVal}
                      disabled={editScaleId !== '' ? true : false}
                      className={editScaleId !== '' ? 'bgc-background-gray' : '' }
                    />
                    }
                    placeholder='Select Grower'
                    handleSelection={option => {handleGrowerSelection(option)}}
                    options={growersFromProdPlan}
                    control={control}
                    name='grower'
                    id='grower'
                    rules={{ required: true }}
                  />
                </div>
              </div>

              <div className='df jcsa'>
                <div className='w45%'>
                  <label className='fz13' htmlFor='ticketNumber'>Ticket Number</label>
                  <input
                    className={`bd2-s-input mt4 fz15 h48 ${editScaleId !== '' ? 'bgc-background-gray' : ''}`}
                    type="text"
                    id='ticketNumber'
                    name="ticketNumber"
                    ref={register({ required: false })} 
                    disabled={editScaleId !== '' ? true : false}
                  />
                </div>
                <div className='w45%'>
                  <label className='fz13' htmlFor='date'>Ticket Date</label>
                  <input
                    className={`bd2-s-input mt4  fz15 h48 w235 ${editScaleId !== '' ? 'bgc-background-gray' : ''}`}
                    type="date"
                    id="date"
                    name="date"
                    value={dateVal}         
                    onChange={handleDateChange}    
                    min="1900-01-01"
                    max="2099-12-31"
                    ref={register({ required: true })}
                    disabled={editScaleId !== '' ? true : false}
                  />

                </div>
              </div>
              <div className='df jcsa'>
                <div className='w45%'>
                  <label className='fz13' htmlFor='netQty'>Net Quantity (bushels)</label>
                  <input
                    className='bd2-s-input mt4 fz15 h48'
                    type="number"
                    id='netQty'
                    name="netQty"
                    ref={register({ required: true })} />
                </div>
                <div className='w45%'>
                  <label className='fz13' htmlFor='grossQty'>Gross Quantity (bushels)</label>
                  <input
                    className='bd2-s-input mt4  fz15 h48'
                    type="number"
                    id='grossQty'
                    name="grossQty"
                    ref={register({ required: false })} />
                </div>
              </div>
              <div className='df jcsa'>
                <div className='w45%'>
                  <label className='fz13' htmlFor='bol'>BOL</label>
                  <input
                    className='bd2-s-input mt4 fz15 h48'
                    type="text"
                    id='bol'
                    name="bol"
                    ref={register({ required: false })} />
                </div>
                <div className='w45%'>
                  <label className='fz13' htmlFor='tw'>Test Weight</label>
                  <input
                    className='bd2-s-input mt4  fz15 h48'
                    type="number"
                    id='tw'
                    name="tw"
                    ref={register({ required: false })} />
                </div>
              </div>
              <div className='df jcsa'>
                <div className='w45%'>
                  <label className='fz13' htmlFor='mo'>Moisture</label>
                  <input
                    className='bd2-s-input mt4 fz15 h48'
                    type="number"
                    id='mo'
                    name="mo"
                    ref={register({ required: false })} />
                </div>
                <div className='w45%'>
                  <label className='fz13' htmlFor='dmg'>Damage</label>
                  <input
                    className='bd2-s-input mt4  fz15 h48'
                    type="number"
                    id='dmg'
                    name="dmg"
                    ref={register({ required: false })} />
                </div>
              </div>
              <div className='df jcsa'>
                <div className='w45%'>
                  <label className='fz13' htmlFor='fm'>Foreign Material</label>
                  <input
                    className='bgc-blue=500 bd2-s-input mt4 fz15 h48'
                    type="text"
                    id='fm'
                    name="fm"
                    ref={register({ required: false })} />
                </div>
                <div className='w45%'>
                  <label className='fz13' htmlFor='dmg'>RVA</label>
                  <div className='df jcsb mt4'>
                    <button name='rva' onClick={e => handleRva(true, e)} className={`w50% bd1-s-black h48 tac lh2.5 curp ${rvaPass ? 'bgc-blue-500 c-white': 'bgc-white'}`} style={{ borderTopLeftRadius: '4px', borderBottomLeftRadius: '4px' }}>Pass</button>
                    <button name='rva' onClick={e => handleRva(false, e)} className={`w50% bd1-s-black h48 tac lh2.5 curp ${rvaPass ? 'bgc-white' : 'bgc-blue-500 c-white'}`} style={{ borderTopRightRadius: '4px', borderBottomRightRadius: '4px' }}>Fail</button>
                  </div>
                </div>
              </div>
              <hr className='mt15 mb16 bdnone bt1-s-lightgray' />
              <div className='df jcsa'>
                <div className='w45%'>
                  <label className='fz13' htmlFor='grossLbs'>Gross Lbs</label>
                  <input
                    className='bd2-s-input mt4 fz15 h48'
                    type="number"
                    id='grossLbs'
                    name="grossLbs"
                    ref={register({ required: false })} />
                </div>
                <div className='w45%'>
                  <label className='fz13' htmlFor='tare'>Tare Lbs</label>
                  <input
                    className='bd2-s-input mt4  fz15 h48'
                    type="number"
                    id='tare'
                    name="tare"
                    ref={register({ required: false })} />
                </div>
              </div>
              <div className='df jcsa'>
                <div className='w45%'>
                  <label className='fz13' htmlFor='netlbs'>Net Lbs</label>
                  <input
                    className='bd2-s-input mt4 fz15 h48'
                    type="number"
                    id='netlbs'
                    name="netlbs"
                    ref={register({ required: false })} />
                </div>
                <div className='w45%'>
                  <label className='fz13' htmlFor='tare'>Notes</label>
                  <input
                    className='bd2-s-input mt4  fz15 h48'
                    type="text"
                    id='notes'
                    name="notes"
                    ref={register({ required: false })} />
                </div>
              </div>
            </form>
          </div>
          <hr className='mt20 mb16 bdnone bt1-s-lightgray' />
          <div className='df jcfe'>
            <div className='mr15'>
              <Button clickHandler={() => {setShowModal(false)}} customClassName="mb10 mr10">Close</Button>
              <Button styleType="success" clickHandler={handleSubmit(onSubmit)} customClassName="mb10">Save</Button>
            </div>
          </div>
        </>)
        break
      case 'LOADING':
        content = <TableStatus status='LOADING'></TableStatus>
        break
      case 'SUCCESS': {
        content = (<div className='df jcc p15'>
          <img src={greenCheck} alt='check mark'></img>
          <div className='ml10'>{editScaleId === '' ? 'Single scale ticket successfully saved' : 'Single scale ticket successfully edited'}</div>
        </div>)
        break
      }
      case 'ERROR': {
        content = <div>
          {statusMessage?.length > 0 && statusMessage[0]?.key_path === 'scale_ticket_duplication' ?
            <>
              <div className='bb1-s-lightgray df jcsb'>
                <div className='df ml15 mt15 mb15'>
                  <img src={error_outline} alt='error icon' />
                  <div className='ml10'>
                    Duplicate scale ticket{statusMessage?.length > 1 && 's' } found which already exists
                  </div>
                </div>
                <img className='mr15 curp' onClick={() => {setShowModal(false)}} src={close}
                  alt='close icon'>
                </img>
              </div>
              <div className='pl20 pb40'>
                <p className="fw600 mb10 tal pl0">Duplicate record{statusMessage?.length > 1 && 's' }:</p>
                {statusMessage?.map((data, index) =>  
                  <div className="tal" key={index}>{data.message}</div>
                )} 
              </div>
            </> : 
            <>
              <div className='bb1-s-lightgray df jcsb'>
                <div className='df ml15 mt15 mb15'>
                  <img src={error_outline} alt='error icon' />
                  <div className='ml10'>
                    {editScaleId === '' ? 'Error uploading single scale ticket' : 'Error updating single scale ticket'}
                  </div>
                </div>
              </div>
              <div className='pl20 pb40'>
                {statusMessage?.map((data, index) =>  
                  <p className='tal'  key={index}>{data.message}</p>
                )} 
              </div>
            </>
          }
        </div>
        break
      }
      default:
        break
    }
    return content
  }


  return (
    <div>
      <Modal
        autoHeight
        show={showModal}
        handleClose={() => setShowModal(false)}
        handleCloseToast={() => setShowModal(false)}
      >
        <div className='w580px h100% bgc-white bd2-s-input bxshmodal bdrs-4'>
          {renderContent(status)}
          <div className='mt8 mb8 mr8 df jcfe'>
            {(status === 'SUCCESS' || status === 'ERROR') && <Button customClassName='mr8 miw75 pl1 pr1' text='Close' onClick={handleClose} />}
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default SingleTicketUpload